import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';

import { BaseApiEndpointService } from './base-api-endpoint.service';
import { QuoteEndpoints } from './models/quotes-endpoint.model';

@Injectable({ providedIn: 'root' })
export class QuotesApiEndpointService extends BaseApiEndpointService {
  constructor(protected store: Store) {
    super(store, 'quote');
  }

  getQuoteUrl(brand: string, quoteId?: string): string {
    return this.constructUrl(QuoteEndpoints.Quote(brand, quoteId));
  }

  getPurchaseUrl(brand: string): string {
    return this.constructUrl(QuoteEndpoints.Purchase(brand));
  }

  getQuoteCommunicationUrl(brand: string, quoteId: string): string {
    return this.constructUrl(QuoteEndpoints.Communication(brand, quoteId));
  }
}
